import { useMemo } from 'react'

import { AgChartOptions } from 'ag-charts-community'
import { parse } from 'date-fns'

import { CustomAgChart } from '@fortem-monorepo/react-ag'
import { ICReport } from '@fortem-monorepo/web-sdk'

import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { commodities } from '@/react-query/queries/ic-report/hooks'

type DataKey = keyof ICReport.GetCommodityCurvesData[number]

export interface CommodityCrudeOilChartProps extends ICReportChartPrimitive {}

export const CommodityCrudeOilChart: React.FC<CommodityCrudeOilChartProps> = ({
  params,
  options,
}) => {
  const query = commodities.useCurves(params)
  const data = query.data ?? []

  const formattedData = useMemo(() => {
    return data.map((item) => {
      return {
        ...item,
        index: new Date(parse(item.index, 'LLL yy', new Date())),
        // "WTI Crude Oil Exposure": item["WTI Crude Oil Exposure"] ?? 0,
      }
    })
  }, [data])

  const mergedOptions: AgChartOptions = {
    title: {
      text: 'Crude Oil',
    },
    series: [
      {
        data: formattedData,
        type: 'line',
        xKey: 'index',
        yKey: 'WTI Crude Oil',
        showInLegend: false,
        interpolation: { type: 'smooth' },
        marker: {
          size: 0,
        },
      },
      {
        data: formattedData,
        type: 'bar',
        xKey: 'index' satisfies DataKey,
        yKey: 'WTI Crude Oil Exposure' satisfies DataKey,
        showInLegend: false,
      },
    ],
    axes: [
      {
        type: 'number',
        position: 'left',
        keys: ['WTI Crude Oil'] satisfies DataKey[],
      },
      {
        type: 'unit-time',
        position: 'bottom',
        parentLevel: {
          enabled: true,
        },
        label: {
          format: '%b %y',
        },
      },
      {
        type: 'number',
        position: 'right',
        keys: ['WTI Crude Oil Exposure'] satisfies DataKey[],
      },
    ],
    ...options,
  }

  return <CustomAgChart options={mergedOptions} />
}
